// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inputPopHeader{position:relative}.smallInput{border:1px solid #ccc;position:absolute;width:100%;max-width:200px;min-height:130px;max-height:250px;border-radius:10px;background:#fff}", ""]);
// Exports
module.exports = exports;
